export interface ITooltipProps {
  text: string | React.ReactNode;
  children: React.ReactNode;
  containerClassName?: string;
  tooltipClassName?: string;
  position?: keyof typeof Positions;
  trigger?: boolean;
  offset?: OffsetProps;
}

export enum Positions {
  top = 'top',
  'top-left' = 'top-left',
  'top-right' = 'top-right',
  right = 'right',
  'right-top' = 'right-top',
  'right-bottom' = 'right-bottom',
  bottom = 'bottom',
  'bottom-left' = 'bottom-left',
  'bottom-right' = 'bottom-right',
  left = 'left',
  'left-top' = 'left-top',
  'left-bottom' = 'left-bottom',
}

export type Offset = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export interface OffsetProps {
  top?: number | string;
  right?: number | string;
  bottom?: number | string;
  left?: number | string;
}

export type PositionParam = keyof typeof Positions;

export type PositionHandler = {
  [key in Positions]: (
    position: PositionParam,
    container: DOMRect,
    tooltip: DOMRect,
    tooltipRef: HTMLSpanElement,
    offset: Offset
  ) => void;
};
